// extracted by mini-css-extract-plugin
export var inline = "_w9-0";